
export default {
  path: 'categories',
  component: () => import(/* webpackChunkName: "event" */ './wrapper.vue'),
  children: [{
    path: '/',
    name: 'event.discipline.categories',
    component: () => import(/* webpackChunkName: "event" */ './list.vue'),
  }, {
    path: 'add',
    name: 'event.discipline.categories.add',
    component: () => import(/* webpackChunkName: "event" */ './add.vue'),
  }, {
    path: ':categoryId',
    name: 'event.discipline.categories.view',
    component: () => import(/* webpackChunkName: "event" */ './view.vue'),
  }]
}
